<script>
    /**
     * @typedef {import('../../services/ValueService.js').ValueCssColor} ValueCssColor
     */

    import { getContext, setContext } from 'svelte';
    import { ValueService } from '../../services/ValueService.js';

    /**
     * @type {{
     *     bg?: boolean | string | null,
     *     children?: import("svelte").Snippet,
     * }}
     */
    let { bg = null, children } = $props();

    const tableBg = $derived(getContext('ly-table-colors')?.value?.next);
    const tableBodyBg = $derived(getContext('ly-table-tbody-colors')?.value?.next);
    const useBg = $derived(bg !== null ? bg : (tableBodyBg ?? tableBg ?? true));

    /** @type {{value:ValueCssColor|null}} */
    let colors = $state({ value: null });
    $effect(() => {
        colors.value = ValueService.splitCssColor(useBg, true);
    });
    setContext('ly-table-tbody-row-colors', colors);

    // -
    const rowCounter = getContext('ly-table-tbody-row-counter');
    const rowNo = rowCounter.value++;
    const isOdd = rowNo % 2 === 1;
</script>

<tr data-row-no={rowNo} class={isOdd ? colors.value?.bg1 || '' : colors.value?.bg2 || ''}>
    {@render children?.()}
</tr>
